import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

const ShipmentProcessesContext = createContext(null);

export const ShipmentProcessesProvider = ({ children }) => {
  const token = localStorage.getItem("controllerToken");
  const host = window.location.hostname;
  const protocol = window.location.protocol.includes("https") ? "wss" : "ws";
  const url = `${protocol}://${host}/automation/ws/shipment_processes?token=${token}`;
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [shipmentProcesses, setShipmentProcesses] = useState(null);
  const listenersRef = useRef(new Set());

  useEffect(() => {
    const ws = new WebSocket(url);

    ws.onopen = () => {
      setIsConnected(true);
    };

    ws.onclose = () => {
      setIsConnected(false);
      // Optional: Reconnect automatically
      setTimeout(() => setSocket(new WebSocket(url)), 3000);
    };

    ws.onerror = (err) => {
      ws.close();
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setShipmentProcesses(data);
    };

    setSocket(ws);

    return () => {
      ws.close();
    };
  }, [url]);

  const sendMessage = (message) => {
    if (socket && isConnected) {
      socket.send(JSON.stringify(message));
    } else {
      console.warn("[WebSocket] Tried to send while disconnected", message);
    }
  };

  const addListener = (callback) => {
    listenersRef.current.add(callback);
    return () => listenersRef.current.delete(callback);
  };

  return (
    <ShipmentProcessesContext.Provider
      value={{
        socket,
        isConnected,
        sendMessage,
        addListener,
        shipmentProcesses,
      }}
    >
      {children}
    </ShipmentProcessesContext.Provider>
  );
};

export const useShipmentProcesses = () => useContext(ShipmentProcessesContext);
